<template>
  <li 
    role="separator" 
    class="mdc-menu-divider mdc-list-divider"/>
</template>

<script>
export default {
  name: 'mdc-menu-divider'
}
</script>
